import DefaultDataGrid from "components/MUI/DataGrid/DefaultDataGrid";

import { getReferencesColumns } from "./References.columns";
import { referencesRows } from "./References.data";

interface ReferencesTableProps {
  onActionClick: (_number: number) => void;
}

const ReferencesTable = ({ onActionClick }: ReferencesTableProps) => {
  const columns = getReferencesColumns(onActionClick);

  return (
    <DefaultDataGrid
      loading={false}
      rows={referencesRows}
      columns={columns}
      getRowHeight={() => "auto"}
      disableRowSelectionOnClick
      pageSizeOptions={[5, 10, 20]}
      initialState={{
        pagination: { paginationModel: { pageSize: 20 } },
      }}
      sx={{
        "& .MuiDataGrid-cell": {
          alignItems: "flex-start",
          py: 1,
        },
      }}
    />
  );
};

export default ReferencesTable;
